import { Button } from 'primereact/button';
import { useQueryLoader } from 'react-relay';
import { getAssignmentReport } from '../../graphQLOperations/Assignment';
import { AssignmentMonitoringQuery } from '../../graphQLOperations/__generated__/AssignmentMonitoringQuery.graphql';
import { FC, useState } from 'react';
import { AssignmentContentWrapper } from './AssignmentContentWrapper';
import { AssignmentItemList } from '../../models/Assignment';
import { AssignmentEditModal } from './AssignmentEditModal';
import { format } from 'date-fns';
import { AssignmentUpdateMutation$variables } from '../../graphQLOperations/__generated__/AssignmentUpdateMutation.graphql';
import { AssignmentDeleteModal } from './AssignmentDeleteModal';

interface Props {
  assignment: AssignmentItemList;
  updateAssignmentHandler: (variables: AssignmentUpdateMutation$variables) => void;
  cancelAssignmentHandler: (assignmentId: string) => void;
}

export const AssignmentTableRowContent: FC<Props> = ({
  assignment,
  updateAssignmentHandler,
  cancelAssignmentHandler,
}) => {
  const [queryReference, loadQuery] = useQueryLoader<AssignmentMonitoringQuery>(getAssignmentReport);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  return (
    <div className="p-2 background-ligth-gray h-50rem border border-round-xl" style={{ fontFamily: 'Poppins' }}>
      <div className="p-2 flex justify-content-between align-items-center">
        <div className="text-800 flex align-items-center">
          <i className="nc_icon-nc_calendar icon-sm text-primary mr-2" />
          <span>
            When to display: <span className="font-semibold ml-1">{format(assignment.startedOn, 'P')}</span>
            <span className="font-semibold mx-2">/</span>
            Due date:
            <span className="font-semibold ml-1">{format(assignment.dueOn || '', 'P')}</span>
          </span>
        </div>

        <div>
          <Button
            icon="nc_icon-nc_edit icon-sm"
            className="mr-2 h-2rem"
            label="Edit"
            outlined
            onClick={() => setShowEditModal(true)}
          />
          <Button
            icon="nc_icon-nc_trash icon-sm"
            onClick={() => setShowDeleteModal(true)}
            outlined
            className="h-2rem"
          />
        </div>
      </div>
      <div className="mx-2" style={{ backgroundColor: 'grey', height: '0.1rem', opacity: 0.3 }}></div>
      <div className="m-2">
        <div>
          <AssignmentContentWrapper loadQuery={loadQuery} queryReference={queryReference} assignment={assignment} />
        </div>
      </div>
      <AssignmentDeleteModal
        visible={showDeleteModal}
        setVisible={setShowDeleteModal}
        cancelAssignmentHandler={cancelAssignmentHandler}
        assignment={assignment}
      />
      <AssignmentEditModal
        updateAssignmentHandler={updateAssignmentHandler}
        visible={showEditModal}
        setVisible={setShowEditModal}
        assignment={assignment}
      />
    </div>
  );
};
